// src/data/content.js

// Tech stack labels usually don’t need translation;
// keep as-is or translate in i18n if you prefer.
export const STACK = ["React", "Next.js", "Node", "Tailwind", "PostgreSQL", "AWS"];

/**
 * SERVICES is only used for structure/length in your Services page.
 * Text comes from i18n (services.items[...] ...).
 * You can leave it empty or keep 4 items to reflect order.
 */
export const SERVICES = [{}, {}, {}, {}];

/**
 * CASES — now reference i18n keys.
 * Components should call t(case.tagKey), t(case.titleKey), etc.
 */
export const CASES = [
  {
    slug: "inner-manifest",
    tagKey: "cases.innerManifest.tag",
    titleKey: "cases.innerManifest.title",
    summaryKey: "cases.innerManifest.summary",
    bodyKey: "cases.innerManifest.body",
    logo: "/logos/inner-manifest.svg",
    url: "https://inner-manifest.ro/",
  },
  {
    slug: "neutralize-barbershop",
    tagKey: "cases.neutralize.tag",
    titleKey: "cases.neutralize.title",
    summaryKey: "cases.neutralize.summary",
    bodyKey: "cases.neutralize.body",
    logo: "/logos/neutralized.svg",
    url: "https://neutralized.eu/programeaza-te",
  },
  {
    slug: "redglassauto",
    tagKey: "cases.redglassauto.tag",
    titleKey: "cases.redglassauto.title",
    summaryKey: "cases.redglassauto.summary",
    bodyKey: "cases.redglassauto.body",
    logo: "/logos/redglassauto.svg",
    url: "https://redglassauto.ro/",
  },
  {
    slug: "twogetters",
    tagKey: "cases.twogetters.tag",
    titleKey: "cases.twogetters.title",
    summaryKey: "cases.twogetters.summary",
    bodyKey: "cases.twogetters.body",
    logo: "/logos/twogetters.svg",
    url: "https://2getters.com/",
  },
];

/**
 * CLIENTS — same idea: only keys here, text via i18n.
 */
export const CLIENTS = [
  {
    nameKey: "clients.innerManifest.name",
    blurbKey: "clients.innerManifest.blurb",
    industryKey: "clients.innerManifest.industry",
    logo: "/logos/inner-manifest.svg",
    url: "https://inner-manifest.ro/",
  },
  {
    nameKey: "clients.neutralize.name",
    blurbKey: "clients.neutralize.blurb",
    industryKey: "clients.neutralize.industry",
    logo: "/logos/neutralized.svg",
    url: "https://neutralized.eu/programeaza-te",
  },
  {
    nameKey: "clients.redglassauto.name",
    blurbKey: "clients.redglassauto.blurb",
    industryKey: "clients.redglassauto.industry",
    logo: "/logos/redglassauto.svg",
    url: "https://redglassauto.ro/",
  },
  {
    nameKey: "clients.twogetters.name",
    blurbKey: "clients.twogetters.blurb",
    industryKey: "clients.twogetters.industry",
    logo: "/logos/twogetters.svg",
    url: "https://2getters.com/",
  },
];
